import React, { useState, useEffect } from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import useNavbarStyles from './navbarStyles';
import { useNavigate , useLocation} from 'react-router-dom';
import MobileNavbar from './components/MobileNavbar';
import DefaultNavbar from './components/DefaultNavbar';


const Navbar = () => {
  const classes = useNavbarStyles();
  const theme = useTheme();
  //Check if the device is mobile
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const navigate = useNavigate();
  const location = useLocation();

  // Check if the current route is the home page
  const isHomePage = location.pathname === '/';
  const [isScrolled, setIsScrolled] = useState(!isHomePage);

  useEffect(() => {
    const handleScroll = () => {
      if (!isHomePage) {
        setIsScrolled(true);
      } else {
        setIsScrolled(window.scrollY > 50);
      }
    };

    // Check initial scroll state
    handleScroll();

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };

    // Re-run effect when `isHomePage` changes
  }, [isHomePage]);

  return (
    <AppBar
      position="fixed"
      //Add elevation when scrolled or not on the home page
      elevation={isScrolled ? 4 : 0}
      className={`${classes.appBar} ${isScrolled ? classes.navScrolled : classes.navTransparent}`}
    >
      <Toolbar className={classes.toolbar}>

        {/* Logo Section */}
        <div className={classes.logoContainer} onClick={() => navigate('/')}>
          <img
           src= "/logo.svg"
           alt= "Paketpost Horizons Logo"
           className={`${classes.logoImage} ${isScrolled ? classes.svglogoDark : classes.svglogoWhite}`}
          />
            <Typography
              className={isScrolled ? classes.logoDark : classes.logoWhite}
              onClick={() => navigate('/')}>
              Paketpost Horizons
            </Typography>
        </div>

        {/* Render either MobileNavbar or DefaultNavbar */}
        {isMobile ? <MobileNavbar isScrolled={isScrolled}/> : <DefaultNavbar isScrolled={isScrolled} />}
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;